module.exports = __webpack_public_path__ + "static/media/ePosterElevatorDarker.c63eae22.jpg";